module.exports = __webpack_public_path__ + "media/song-sparrow-2.950f9d95.mp3";